import './App.css';
import Header from './Header';
import './Header.css';
import Shop from './shop/Shop';

function App() {
  return (
    <div>
      <Header></Header>
      <Shop></Shop>
    </div>
  );
}

export default App;